import InventoryForm from "./InventoryForm.presenter";
export default InventoryForm;
